abstract class BaseCookieConsentManager {
    private spinner: HTMLElement;

    protected constructor(spinner: HTMLElement) {
        this.spinner = spinner;
    }

    public sendSelectedValues(onSuccess: () => void) {
        this.spinner.classList.remove('u-hidden');
        fetch(this.prepareAndReturnApiEndpointLink())
            .then(response => response.json())
            .then(response => {
                this.onConsentStored(response);
                onSuccess && onSuccess();
            })
            .catch(error => console.error('Unable to send custom selection (sendSelectedValues)', error));
    }

    protected abstract prepareAndReturnApiEndpointLink(): string

    private onConsentStored(response: { result: boolean, consent: number }) {
        this.spinner.classList.add('u-hidden');
        if (response.result) {
            document.dispatchEvent(new CustomEvent('cookiesConsentStored', {detail: {consent: response.consent}}));
            window.cookieConsent = response.consent;
        }
    }
}

class FormCookieConsentManager extends BaseCookieConsentManager {
    private constructor(
        private readonly formAction: string,
        private readonly data: FormData, // Na FE je zobrazen form, ale requesty na server jsou vždy jako GET requesty přes fetch, formulář je použit pouze kvůli renderování. Z formuláře se načítá aktuální nastavení.
        spinner: HTMLElement,
    ) {
        super(spinner);
    }

    protected prepareAndReturnApiEndpointLink(): string {
        const params = new URLSearchParams();
        this.data.forEach((e, i) => params.append(i, e.toString()));
        params.set('redirect', '0');
        return this.formAction + "?" + params.toString();
    }

}

class LinkCookieConsentManager extends BaseCookieConsentManager {
    private constructor(
        private readonly link: string,
        spinner: HTMLElement,
    ) {
        super(spinner);
    }

    protected prepareAndReturnApiEndpointLink(): string {
        return this.link + '&redirect=0'; // Vychází z knihovny poski/cookies, kde je vždy link s parametry a tedy stačí parametr appendnout
    }

}
